<main class="bg-off-white flex p-[20px] justify-evenly gap-x-[20px]">
	<!-- CREATED PRODUCT  -->
	<section>
		<h1 class="text-font-16 mb-12px">Created Product</h1>
		<div class="h-[1px] w-full bg-secondry-color-Gray mb-12px"></div>
		<div class="py-12px px-24px bg-[#F5F5F5] rounded-12px">
			<!-- FEATURED IMAGES  -->
			<div class="mb-12px">
				<h1 class="font-DIN-bold font-bold text-dark-grey text-font-12 mb-8">
					Feature Image
				</h1>
				<div class="flex">
					<img
						class="w-[62px] h-[62px] rounded-12px mr-8px"
						src="https://gate-academy-eg.com/wp-content/uploads/2021/07/Scientists-Have-Found-Toxic-Substances-in-Popular-Cosmetics1-1.jpg"
						alt=""
					/>
					<img
						class="w-[62px] h-[62px] rounded-12px mr-8px"
						src="https://gate-academy-eg.com/wp-content/uploads/2021/07/Scientists-Have-Found-Toxic-Substances-in-Popular-Cosmetics1-1.jpg"
						alt=""
					/>
					<img
						class="w-[62px] h-[62px] rounded-12px mr-8px"
						src="https://gate-academy-eg.com/wp-content/uploads/2021/07/Scientists-Have-Found-Toxic-Substances-in-Popular-Cosmetics1-1.jpg"
						alt=""
					/>
				</div>
			</div>
			<!-- FEATURED IMAGES  -->

			<!-- PRODUCT DETAILS  -->
			<div class="mb-12px">
				<h1 class="font-DIN-bold font-bold text-font-16 text-dark-grey mb-16px">
					Product information
				</h1>
				<div class="py-12px px-24px rounded-12px bg-off-white sectionShadow">
					<div>
						<h1 class="text-font-14 text-medium-gray">Product Name [EN]</h1>
						<p class="text-font-16 text-dark-grey">Product Name [EN]</p>
					</div>
					<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
					<div>
						<h1 class="text-font-14 text-medium-gray">Product Name [AR]</h1>
						<p class="text-font-16 text-dark-grey">Product Name [AR]</p>
					</div>
					<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
					<div>
						<h1 class="text-font-14 text-medium-gray">
							Describe your product [EN]
						</h1>
						<p class="text-font-16 text-dark-grey">
							Lorem ipsum dolor sit amet consectetur. Nibh congue cursus
							venenatis rhoncus erat.
						</p>
					</div>
					<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
					<div>
						<h1 class="text-font-14 text-medium-gray">
							Describe your product [AR]
						</h1>
						<p class="text-font-16 text-dark-grey">
							لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على العميل
							ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم مطبوعه
						</p>
					</div>
				</div>
			</div>
			<!-- PRODUCT DETAILS  -->
			<!-- CATEGORY-BRAND  -->
			<div
				class="py-12px px-24px rounded-12px bg-off-white sectionShadow mb-12px"
			>
				<div>
					<h1 class="text-font-14 text-medium-gray">Category</h1>
					<p class="text-font-16 text-dark-grey">Category</p>
				</div>
				<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
				<div>
					<h1 class="text-font-14 text-medium-gray">Brand</h1>
					<p class="text-font-16 text-dark-grey">Brand</p>
				</div>
			</div>
			<!-- CATEGORY-BRAND  -->

			<!-- PRICE AND QUANTITY  -->
			<div
				class="py-12px px-24px rounded-12px bg-off-white sectionShadow mb-12px"
			>
				<div>
					<h1 class="text-font-14 text-medium-gray">Inventory</h1>
					<p class="text-font-16 text-dark-grey">10 Available</p>
				</div>
				<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
				<div>
					<h1 class="text-font-14 text-medium-gray">Price</h1>
					<p class="text-font-16 text-dark-grey">SAR 120 | SAR 200</p>
				</div>
			</div>
			<!-- PRICE AND QUANTITY  -->

			<!-- OPTIONS  -->
			<div
				class="py-12px px-24px rounded-12px bg-off-white sectionShadow mb-12px"
			>
				<div>
					<h1 class="text-font-14 text-medium-gray">Color</h1>
					<mat-chip-listbox>
						<mat-chip> red </mat-chip>

						<mat-chip> green </mat-chip>
					</mat-chip-listbox>
				</div>
				<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
				<div>
					<h1 class="text-font-14 text-medium-gray">size</h1>
					<mat-chip-listbox>
						<mat-chip> medium </mat-chip>

						<mat-chip> large </mat-chip>
					</mat-chip-listbox>
				</div>
			</div>
			<!-- OPTIONS  -->
			<!-- VARIANCES  -->
			<div class="custom-table overflow-x-auto">
				<table class="mat-elevation-z8 bg-transparent w-full relative">
					<thead class="bg-light">
						<tr class="border-b-[1px] border-secondry-color-Gray bg-off-white">
							<td
								class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[37px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
							>
								{{ 'variantName' }}
							</td>

							<td
								class="text-font-14 leading-[22px] text-medium-gray py-[14px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
							>
								{{ 'price' }}
							</td>
							<td
								class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
							>
								{{
									'ORGANIZATION.ORGANIZATION_LIST.SERVICEPROVIDERTYPE'
										| translate
								}}
							</td>
							<td
								class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
							>
								{{ 'quantity' }}
							</td>
							<td></td>
						</tr>
					</thead>
					<tbody class="bg-grey-background">
						<tr>
							<td
								class="cursor-pointer text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[37px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
							>
								<span
									class="flex items-center rtl:max-mobile:ml-8 ltr:max-mobile:mr-8 relative"
								>
									<img
										src="./assets/images/logo.png"
										alt=""
										class="w-[56px] h-[56px] rtl:ml-2 ltr:mr-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
									/>
									<span>
										<span class="block whitespace-normal text-dark-grey">
											{{ 'variant name' }}
										</span>
									</span>
								</span>
							</td>

							<td
								class="text-center text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular ltr:pl-[35px] rtl:pr-[22px]"
							>
								<h1
									class="text-font-16 text-dark-grey max-mobile:text-font-12 m-0"
								>
									{{ '300 sar' }}
								</h1>
							</td>
							<td
								class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
							>
								{{ 'Quantity' }}
							</td>
							<td
								class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
							>
								{{ 'Status' }}
							</td>

							<td
								class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
							>
								<span
									class="inline-block max-mobile:w-[20px] w-[16px] text-end"
								>
									<img
										[src]="'assets/images/view.svg'"
										alt=""
										class="inline-block cursor-pointer"
									/>
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!-- VARIANCES  -->
		</div>
	</section>
	<!-- CREATED PRODUCT  -->
	<!-- CURRENT VERSION   -->
	<section>
		<div class="flex justify-between">
			<h1 class="text-font-16 mb-12px">CURRENT Product</h1>
			<svg
				width="23"
				height="23"
				viewBox="0 0 23 23"
				class="cursor-pointer"
				(click)="compareMode.emit(false)"
			>
				<path
					d="M11.4134 21.2272C5.88024 21.2272 1.38281 16.7297 1.38281 11.1966C1.38281 5.66345 5.88024 1.16602 11.4134 1.16602C16.9465 1.16602 21.444 5.66345 21.444 11.1966C21.444 16.7297 16.9465 21.2272 11.4134 21.2272ZM11.4134 2.56563C6.6547 2.56563 2.78243 6.4379 2.78243 11.1966C2.78243 15.9553 6.6547 19.8276 11.4134 19.8276C16.1721 19.8276 20.0444 15.9553 20.0444 11.1966C20.0444 6.4379 16.1721 2.56563 11.4134 2.56563Z"
					fill="#4E4B66"
				/>
				<path
					d="M8.77169 14.5359C8.59441 14.5359 8.41712 14.4706 8.27716 14.3306C8.00657 14.0601 8.00657 13.6122 8.27716 13.3416L13.5584 8.06037C13.829 7.78977 14.2768 7.78977 14.5474 8.06037C14.818 8.33096 14.818 8.77883 14.5474 9.04943L9.26622 14.3306C9.13559 14.4706 8.94898 14.5359 8.77169 14.5359Z"
					fill="#4E4B66"
				/>
				<path
					d="M14.0529 14.5359C13.8756 14.5359 13.6983 14.4706 13.5584 14.3306L8.27716 9.04943C8.00657 8.77883 8.00657 8.33096 8.27716 8.06037C8.54776 7.78977 8.99563 7.78977 9.26622 8.06037L14.5474 13.3416C14.818 13.6122 14.818 14.0601 14.5474 14.3306C14.4075 14.4706 14.2302 14.5359 14.0529 14.5359Z"
					fill="#4E4B66"
				/>
			</svg>
		</div>
		<div class="h-[1px] w-full bg-secondry-color-Gray mb-12px"></div>
		<div class="py-12px px-24px bg-[#F5F5F5] rounded-12px">
			<!-- FEATURED IMAGES  -->
			<div class="mb-12px">
				<h1 class="font-DIN-bold font-bold text-dark-grey text-font-12 mb-8">
					Feature Image
				</h1>
				<div class="flex">
					<img
						class="w-[62px] h-[62px] rounded-12px mr-8px"
						src="https://gate-academy-eg.com/wp-content/uploads/2021/07/Scientists-Have-Found-Toxic-Substances-in-Popular-Cosmetics1-1.jpg"
						alt=""
					/>
					<img
						class="w-[62px] h-[62px] rounded-12px mr-8px"
						src="https://gate-academy-eg.com/wp-content/uploads/2021/07/Scientists-Have-Found-Toxic-Substances-in-Popular-Cosmetics1-1.jpg"
						alt=""
					/>
					<img
						class="w-[62px] h-[62px] rounded-12px mr-8px"
						src="https://gate-academy-eg.com/wp-content/uploads/2021/07/Scientists-Have-Found-Toxic-Substances-in-Popular-Cosmetics1-1.jpg"
						alt=""
					/>
				</div>
			</div>
			<!-- FEATURED IMAGES  -->

			<!-- PRODUCT DETAILS  -->
			<div class="mb-12px">
				<h1 class="font-DIN-bold font-bold text-font-16 text-dark-grey mb-16px">
					Product information
				</h1>
				<div class="py-12px px-24px rounded-12px bg-off-white sectionShadow">
					<div>
						<h1 class="text-font-14 text-medium-gray">Product Name [EN]</h1>
						<p class="text-font-16 text-dark-grey">Product Name [EN]</p>
					</div>
					<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
					<div>
						<h1 class="text-font-14 text-medium-gray">Product Name [AR]</h1>
						<p class="text-font-16 text-dark-grey">Product Name [AR]</p>
					</div>
					<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
					<div>
						<h1 class="text-font-14 text-medium-gray">
							Describe your product [EN]
						</h1>
						<p class="text-font-16 text-dark-grey">
							Lorem ipsum dolor sit amet consectetur. Nibh congue cursus
							venenatis rhoncus erat.
						</p>
					</div>
					<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
					<div>
						<h1 class="text-font-14 text-medium-gray">
							Describe your product [AR]
						</h1>
						<p class="text-font-16 text-dark-grey">
							لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على العميل
							ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم مطبوعه
						</p>
					</div>
				</div>
			</div>
			<!-- PRODUCT DETAILS  -->
			<!-- CATEGORY-BRAND  -->
			<div
				class="py-12px px-24px rounded-12px bg-off-white sectionShadow mb-12px"
			>
				<div>
					<h1 class="text-font-14 text-medium-gray">Category</h1>
					<p class="text-font-16 text-dark-grey">Category</p>
				</div>
				<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
				<div>
					<h1 class="text-font-14 text-medium-gray">Brand</h1>
					<p class="text-font-16 text-dark-grey">Brand</p>
				</div>
			</div>
			<!-- CATEGORY-BRAND  -->

			<!-- PRICE AND QUANTITY  -->
			<div
				class="py-12px px-24px rounded-12px bg-off-white sectionShadow mb-12px"
			>
				<div>
					<h1 class="text-font-14 text-medium-gray">Inventory</h1>
					<p class="text-font-16 text-dark-grey">10 Available</p>
				</div>
				<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
				<div>
					<h1 class="text-font-14 text-medium-gray">Price</h1>
					<p class="text-font-16 text-dark-grey">SAR 120 | SAR 200</p>
				</div>
			</div>
			<!-- PRICE AND QUANTITY  -->

			<!-- OPTIONS  -->
			<div
				class="py-12px px-24px rounded-12px bg-off-white sectionShadow mb-12px"
			>
				<div>
					<h1 class="text-font-14 text-medium-gray">Color</h1>
					<mat-chip-listbox>
						<mat-chip> red </mat-chip>

						<mat-chip> green </mat-chip>
					</mat-chip-listbox>
				</div>
				<div class="h-[1px] w-full bg-secondry-color-Gray my-8px"></div>
				<div>
					<h1 class="text-font-14 text-medium-gray">size</h1>
					<mat-chip-listbox>
						<mat-chip> medium </mat-chip>

						<mat-chip> large </mat-chip>
					</mat-chip-listbox>
				</div>
			</div>
			<!-- OPTIONS  -->
			<!-- VARIANCES  -->
			<div class="custom-table overflow-x-auto">
				<table class="mat-elevation-z8 bg-transparent w-full relative">
					<thead class="bg-light">
						<tr class="border-b-[1px] border-secondry-color-Gray bg-off-white">
							<td
								class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[37px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
							>
								{{ 'variantName' }}
							</td>

							<td
								class="text-font-14 leading-[22px] text-medium-gray py-[14px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
							>
								{{ 'price' }}
							</td>
							<td
								class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
							>
								{{
									'ORGANIZATION.ORGANIZATION_LIST.SERVICEPROVIDERTYPE'
										| translate
								}}
							</td>
							<td
								class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
							>
								{{ 'quantity' }}
							</td>
							<td></td>
						</tr>
					</thead>
					<tbody class="bg-grey-background">
						<tr>
							<td
								class="cursor-pointer text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[37px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
							>
								<span
									class="flex items-center rtl:max-mobile:ml-8 ltr:max-mobile:mr-8 relative"
								>
									<img
										src="./assets/images/logo.png"
										alt=""
										class="w-[56px] h-[56px] rtl:ml-2 ltr:mr-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
									/>
									<span>
										<span class="block whitespace-normal text-dark-grey">
											{{ 'variant name' }}
										</span>
									</span>
								</span>
							</td>

							<td
								class="text-center text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular ltr:pl-[35px] rtl:pr-[22px]"
							>
								<h1
									class="text-font-16 text-dark-grey max-mobile:text-font-12 m-0"
								>
									{{ '300 sar' }}
								</h1>
							</td>
							<td
								class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
							>
								{{ 'Quantity' }}
							</td>
							<td
								class="text-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
							>
								{{ 'Status' }}
							</td>

							<td
								class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
							>
								<span
									class="inline-block max-mobile:w-[20px] w-[16px] text-end"
								>
									<img
										[src]="'assets/images/view.svg'"
										alt=""
										class="inline-block cursor-pointer"
									/>
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!-- VARIANCES  -->
		</div>
	</section>
	<!-- CURRENT VERSION   -->
</main>
